/* v=2026-05-16-thumbs */
(() => {
  const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Per-sub-category thumbnails, keyed by collection handle from the link href
  const ITEM_THUMBS = {
    '/collections/bouquets':         'https://cdn.shopify.com/s/files/1/0828/3616/0796/files/0H6A8294-2.jpg?v=1705262950',
    '/collections/boxes':            'https://cdn.shopify.com/s/files/1/0828/3616/0796/collections/41_cd149fb0-3da4-4fba-934e-27ddfaf2c359.png?v=1765889064',
    '/collections/vases-1':          'https://cdn.shopify.com/s/files/1/0828/3616/0796/collections/12_729aa3d0-55af-41ab-9869-b84345667337.png?v=1765889580',
    '/collections/bunches':          'https://cdn.shopify.com/s/files/1/0828/3616/0796/files/0H6A8871-2.jpg?v=1705842293',
    '/collections/flower-bag':       'https://cdn.shopify.com/s/files/1/0828/3616/0796/collections/41.png?v=1765888432',
    '/collections/accessories-1':    'https://cdn.shopify.com/s/files/1/0828/3616/0796/files/3_278f8e30-8bdd-4f8a-96ef-45fad24ec895.png?v=1754345284',
    '/collections/cakes':            'https://cdn.shopify.com/s/files/1/0828/3616/0796/files/revery-dropdown-sweets.jpg?v=1777927366',
    '/collections/chocolates':       'https://cdn.shopify.com/s/files/1/0828/3616/0796/files/565C90AA-6A45-461E-A1E7-9D7A335FF327_1c38abde-63c4-43cc-98d5-5470b10b7ff8.png?v=1777806754',
    '/products/confiserie-grande-sweets-flowers': 'https://cdn.shopify.com/s/files/1/0828/3616/0796/files/1D756469-A2A1-4833-BAAA-82AC53637DA6.png?v=1778683514',
    '/collections/fruits':           'https://cdn.shopify.com/s/files/1/0828/3616/0796/collections/1350_aed.png?v=1778691136',
    '/collections/bundles':          'https://cdn.shopify.com/s/files/1/0828/3616/0796/files/695_aed_1.png?v=1778683416',
    '/collections/birthday':         'https://cdn.shopify.com/s/files/1/0828/3616/0796/collections/4EDBDE79-DD7D-434C-8A74-F5C9C86C25C0.png?v=1778691110',
    '/collections/mothers-day':      'https://cdn.shopify.com/s/files/1/0828/3616/0796/files/12.png?v=1742241948',
    '/collections/valentines-day':   'https://cdn.shopify.com/s/files/1/0828/3616/0796/files/22_fe660851-87b7-42b0-8e37-0cdbf1fee343.png?v=1770671401',
    '/collections/eid':              'https://cdn.shopify.com/s/files/1/0828/3616/0796/files/revery-dropdown-occasions.png?v=1777927391',
    '/collections/uae-national-day': 'https://cdn.shopify.com/s/files/1/0828/3616/0796/files/revery-themed-uae-national-day.jpg?v=1778012574',
    '/collections/bridal':           'https://cdn.shopify.com/s/files/1/0828/3616/0796/files/revery-themed-bridal.jpg?v=1778012596',
    '/collections/halloween':        'https://cdn.shopify.com/s/files/1/0828/3616/0796/files/629AA594-98F7-473B-8E20-6BA2FB376C59.png?v=1778683694'
  };

  const decorateDropdowns = () => {
    document.querySelectorAll('.header__menu-disclosure').forEach((detail) => {
      if (detail.dataset.rvDecorated) return;
      const ul = detail.querySelector('.header__dropdown-menu');
      if (!ul) return;

      const items = ul.querySelectorAll(':scope > li');
      let decorated = 0;
      items.forEach((li) => {
        const link = li.querySelector('a');
        if (!link) return;
        const href = (link.getAttribute('href') || '').split('?')[0].replace(/\/$/, '');
        const thumb = ITEM_THUMBS[href];
        if (!thumb) return;
        if (li.querySelector('.rv-menu-card__figure')) return;

        // Wrap link content in a card structure: image above, text below
        link.classList.add('rv-menu-card');
        const text = link.textContent.trim();
        link.textContent = '';

        const figure = document.createElement('span');
        figure.className = 'rv-menu-card__figure';
        const img = document.createElement('img');
        img.src = thumb;
        img.alt = text;
        img.loading = 'lazy';
        figure.appendChild(img);

        const label = document.createElement('span');
        label.className = 'rv-menu-card__label';
        label.textContent = text;

        link.appendChild(figure);
        link.appendChild(label);
        decorated++;
      });

      if (decorated > 0) {
        ul.classList.add('rv-dropdown--cards');
      }
      detail.dataset.rvDecorated = '1';
    });
  };

  const init = () => {
    decorateDropdowns();

    if (REDUCED) {
      document.querySelectorAll('.rv-reveal').forEach(el => el.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

    document.querySelectorAll('.rv-reveal:not(.is-visible)').forEach(el => observer.observe(el));

    setTimeout(() => {
      document.querySelectorAll('.rv-reveal:not(.is-visible)').forEach(el => {
        const rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight * 1.1) el.classList.add('is-visible');
      });
    }, 350);

    setTimeout(() => {
      document.querySelectorAll('.rv-reveal:not(.is-visible)').forEach(el => el.classList.add('is-visible'));
    }, 2500);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', () => {
    document.querySelectorAll('.rv-reveal:not(.is-visible)').forEach(el => el.classList.add('is-visible'));
  });
})();
